import { createSelector } from '@reduxjs/toolkit';

export const isBootstrapped = createSelector([(state: any) => state.auth.bootstrapped], bootstrapped => bootstrapped);
